export * from './team';
export * from './social-links';
export * from './launchpads';
export * from './ecosystem-links';

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
